import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { BitmapText, Color, Container, FillGradient, Sprite, Text, TextStyle } from "pixi.js";
import { Group, Tween } from "tweedle.js";
import { currentBackgorundMusic, currentBackgorundMusicVolume, globalScreen, isMusicBtnOnGlobal, languageGlobal, setBackgorundMusic } from "../config/GlobalVariableConfig";
import { getFontConfig } from "../config/introTextConfig";
import { SoundConstants } from "../gameClientEvents/soundConstants";
import { isFireFox } from "../utils";

declare const window: any;
const translationManager = window.hacksawCasino.Translation;

// import { setBackgorundMusic, currentBackgorundMusicVolume } from "../config/GlobalVariableConfig";

export class Banner extends Container {

    private bgContainer = new Container();
    private texContainer = new Container(); //-- which needed to scale without any limit
    private texContainerWrapper = new Container();
    private backgroundImg: Sprite;

    private bannerText1: Text = new Text({});
    private bannerText2: Text = new Text({});
    private bannerText3: Text = new Text({});
    private freegameCheck: boolean = false;
    // private bannerText4: Text = new Text({});
    // private bannerText5: Text = new Text({});
    private continueText: Text = new Text({});

    // -- Added base sprite for continue text
    // private continueBase: Sprite;

    // private backgroundSpine: Spine | null = null;

    private winText: BitmapText = new BitmapText({
        text: "",
        style: {
            fontFamily: "symbol_multiplier",
            trim: true,
            fontSize: 175,
            letterSpacing: 5,
        }
    });

    private baseAnim: Spine | null = null;
    // private transitionAnim: Spine | null = null;
    //private rightCharacter: Spine | null = null;
    // private rightCharacter: Sprite | null = null;

    private tweenGroup: Group = new Group();

    private screenWidth: number;
    private screenHeight: number;


    constructor(screenWidth: number, screenHeight: number) {
        super();



        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        this.setupBGImage();

        this.setupBackground();
        this.setupBannerText();

        this.setupBaseAnim();

        // this.setupTransitionAnim();
        this.visible = false;

        // this.bgContainer.eventMode = "static"
        this.resize(screenWidth, screenHeight);

    }

    private setupBGImage(): void {
        // this.backgroundImg.label = "backgroundImg";

        this.backgroundImg = Sprite.from("freegame_intro_bg");
        this.backgroundImg.alpha = 0;
        this.backgroundImg.label = "backgroundImg";
        this.addChild(this.backgroundImg);
    }
    private setupBackground(): void {
        this.addChild(this.bgContainer);
    }

    private setupBaseAnim(): void {

        this.baseAnim = Spine.from({
            skeleton: "bannerBaseSkel",
            atlas: "bannerBaseAtlas"
        });

        this.baseAnim.state.apply(this.baseAnim.skeleton);

        this.baseAnim.visible = false;
        this.baseAnim.label = "baseAnime";

        this.bgContainer.addChild(this.baseAnim);
        this.texContainerWrapper.addChild(this.texContainer);
        // Attach ALL text to spine
        // this.baseAnim.addSlotObject(
        //     "CLICK TO CONTINUE",
        //     this.texContainerWrapper
        // );
    }
    // private setupTransitionAnim() {
    //     this.transitionAnim = Spine.from({
    //         skeleton: "transitionSkel",
    //         atlas: "transitionAtlas"
    //     })
    //     this.transitionAnim.visible = false;
    //     this.transitionAnim.position.set(1920 / 2, 1080 / 2);
    //     this.bgContainer.addChild(this.transitionAnim);
    // }


    private setupBannerText(): void {

        const {
            fontFamily: fontFamilyHeading,
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
        } = getFontConfig(languageGlobal, "introHeading");



        const fill = new FillGradient(0, 0, 0, fontSizeHeading * 1.4);
        const colors = ["#f83600", "#facc22"].map((color) => Color.shared.setValue(color).toNumber());

        colors.forEach((number, index) => {
            const ratio = index / colors.length;

            fill.addColorStop(ratio, number);
        });

        this.bannerText1.style = new TextStyle({
            fontFamily: fontFamilyHeading,
            fill: isFireFox() ? "#ffffff" : { fill },
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
            stroke: {
                color: "#843e06",
                width: 2,
                join: "round"
            },
            dropShadow: isFireFox() ? false :
                {
                    blur: 1,
                    color: "#fa7d07",
                    distance: 1,
                    alpha: 1
                },
            letterSpacing: 2,
            align: "center",
            // breakWords: true,
            // wordWrap: true,
            // wordWrapWidth: 850,

        });



        const {
            fontFamily: fontFamilyDesc1,
            fontWeight: fontWeightDesc1,
            fontSize: fontSizeDesc1,
            lineHeight: lineHeightDesc1
        } = getFontConfig(languageGlobal, "introDesc1")

        this.bannerText2.style = new TextStyle({
            fontFamily: fontFamilyDesc1,
            fill: "#ffac28",
            fontWeight: fontWeightDesc1,
            fontSize: fontSizeDesc1,
            stroke: {
                color: "#594627",
                width: 2,
            },
            dropShadow: isFireFox() ? false :
                {
                    blur: 5,
                    color: "#020202",
                    distance: 5,
                    alpha: 1
                },
            align: "center",
            // trim: true,
            letterSpacing: 1,
            // fontVariant: "small-caps",
            breakWords: true,
            wordWrap: true,
            wordWrapWidth: 1000,
            lineHeight: lineHeightDesc1,
        });

        const {
            fontFamily: fontFamilyDesc2,
            fontWeight: fontWeightDesc2,
            fontSize: fontSizeDesc2,
            lineHeight: lineHeightDesc2
        } = getFontConfig(languageGlobal, "introDesc2");

        const desc2TextStyle = new TextStyle({
            fontFamily: fontFamilyDesc2,
            fill: "#fde9b3",
            fontWeight: fontWeightDesc2,
            fontSize: fontSizeDesc2,
            // stroke: {
            //     color: "#935a10",
            //     width: 2,
            // },
            // dropShadow: isFireFox() ? false :
            //     {
            //         blur: 5,
            //         color: "#011932",
            //         distance: 0,
            //         alpha: 1
            //     },
            align: "center",
            wordWrap: true,
            // trim: true,
            letterSpacing: 1,
            wordWrapWidth: 950,
            lineHeight: lineHeightDesc2,
            breakWords: true,
        });

        this.bannerText3.style = desc2TextStyle;
        // this.bannerText4.style = desc2TextStyle;
        // this.bannerText5.style = desc2TextStyle;


        const {
            fontFamily: fontFamilyContinue,
            fontWeight: fontWeightContinue,
            fontSize: fontSizeContinue2,
        } = getFontConfig(languageGlobal, "introContinue");

        const continueTextStyle = new TextStyle({
            fontFamily: fontFamilyContinue,
            fill: isFireFox() ? "#ffffff" : { fill },//"#ffffff",
            fontWeight: fontWeightContinue,
            fontSize: fontSizeContinue2,
            stroke: {
                color: "#843e06",
                width: languageGlobal === "en-us" ? 2 : 1,
                join: "round"
            },
            dropShadow: isFireFox() ? false :
                {
                    blur: languageGlobal === "en-us" ? 3 : 1,
                    color: "#fa7d07",
                    distance: 1,
                    alpha: 1
                },
        });

        this.continueText.text = translationManager.game('intro_continue_uc')
        this.continueText.style = continueTextStyle

        // -- SETUP CONTINUE BASE SPRITE --
        // this.continueBase = Sprite.from("continueBase1");
        // this.continueBase.anchor.set(0.5);
        // this.continueBase.scale.set(0.9);
        // if(this.continueText.width > this.continueBase.width){
        //     this.continueText.style.fontSize = 44;
        //     this.continueBase.scale.set(1.1,1);
        // }


        this.bannerText1.anchor.set(0.5);
        this.bannerText1.style.fontSize = 70;
        this.bannerText2.anchor.set(0.5);
        this.bannerText3.anchor.set(0.5);
        // this.bannerText4.anchor.set(0.5);
        // this.bannerText5.anchor.set(0.5);
        this.continueText.anchor.set(0.5);
        this.winText.anchor.set(0.5);

        // const spacing = 20;
        this.texContainer.addChild(this.bannerText1);
        this.texContainer.addChild(this.bannerText2);
        this.texContainer.addChild(this.bannerText3);
        // this.texContainer.addChild(this.bannerText4);
        // this.texContainer.addChild(this.bannerText5);

        // Add base before text so it is behind
        // this.texContainer.addChild(this.continueBase);
        this.texContainer.addChild(this.continueText);

        this.texContainer.addChild(this.winText);
        // this.texContainer.alpha = 1;
        this.texContainer.alpha = 0;
    }

    private isIntroBanner: boolean = true;

    public async appearFreeGameIntroBanner(freeGameNumber: number) {

        return new Promise<void>(async (resolve) => {
            this.eventMode = "static";
            this.cursor = "pointer";
            this.freegameCheck = true;
            this.isIntroBanner = true;
            // this.visible = true;
            this.bannerText1.visible = true;
            this.bannerText2.visible = true;
            this.bannerText3.visible = true;
            // this.bannerText4.visible = true;
            // this.bannerText5.visible = true;

            this.winText.visible = false;

            this.bannerText1.scale.set(1);
            this.bannerText1.text = translationManager.game('banner_intro_heading_uc');// '8-BIT BONUS';
            this.bannerText1.scale.set(Math.min(1, 650 / this.bannerText1.width));
            this.bannerText1.y = -350;

            // this.bannerText2.scale = 1;

            this.bannerText2.text = translationManager.game('banner_intro_desc_1', null, { 'freegamenumber': freeGameNumber });//`You won ${freeGameNumber} Free Spins!`
            this.bannerText2.y = -225;
            // this.bannerText2.scale = Math.min(1, 850 / this.bannerText2.width);
            while (this.bannerText2.width > 980) {
                this.bannerText2.style.fontSize -= 1;
            }

            this.bannerText3.text = translationManager.game('banner_intro_desc_2');//'During the bonus game, the multiplier accumulates with each win that involves a wild symbol with a multiplier.';
            this.bannerText3.y = 65;
            // this.bannerText3.scale = Math.min(1, (this.bannerBackground.width - 150) / this.bannerText3.width);

            // this.bannerText4.text = translationManager.game('banner_intro_desc_3');//'The multiplier persists throughout the entire duration of the bonus game.';
            // this.bannerText4.y = 115;

            // this.bannerText5.text = translationManager.game('banner_intro_desc_4');//'The multiplier persists throughout the entire duration of the bonus game.';
            // this.bannerText5.y = 350;

            this.continueText.y = 350;


            this.texContainerWrapper.visible = false;
            this.resize(this.screenWidth, this.screenHeight); // to set the position according to screen size

            // Text should be visible and transform along with spine "in"
            // this.texContainer.scale.set(1);

            this.visible = true;

            // sound.play('free_Game_Banner', { volume: 0.5 });

            // this.backgroundSpine.state.setAnimation(0, "in", false).listener = {
            //     complete: async () => {
            //         this.backgroundSpine.state.setAnimation(0, "loop", true);

            //         await this.appearText(true);
            //         resolve();

            //         this.backgroundSpine.state.clearListeners();
            //     }
            // };

            ["es-es", "de-de", "it-it", "pt-br", "pt-pt", "nl-nl", "id-id", "vi-vn", "bg-bg", "el-gr", "ru-ru"].forEach((lang) => {
                if (languageGlobal === lang) {
                    this.bannerText3.style.fontSize = 60;
                    // this.bannerText4.style.fontSize = 36;
                }
            });

            if (languageGlobal === "lt-lt") {
                this.bannerText1.style.fontSize = 68;
            }



            await new Promise<void>((resolve) => {
                const tween = new Tween(this.backgroundImg, this.tweenGroup)
                    .to({ alpha: 1 }, 350)
                    .onStart(() => {
                        // sound.play('free_Game_Banner', { volume: 0.5 });
                    })
                    .onComplete(() => {
                        this.tweenGroup.remove(tween);
                        resolve()
                    })
                    .start();
            })



            const promises: Promise<void>[] = [];
            const playInAnimation = (baseAnimSpine: Spine) => {
                return new Promise<void>(async (resolve) => {
                    baseAnimSpine.visible = true;
                    sound.play(SoundConstants.TEXT_APPEAR, { volume: 1 });
                    baseAnimSpine.state.setAnimation(0, "in", false).listener = {
                        event: async (entry, event) => {
                            if (event.data.name === "event") {
                                console.log(".........", entry);
                                this.baseAnim.addSlotObject(
                                "CLICK TO CONTINUE",
                                    this.texContainerWrapper
                                );
                                this.texContainerWrapper.visible = true;
                                //this.texContainer.alpha = 1;
                                //await this.appearText(true);
                                this.switchTheBackgroundMusic(true);
                            }
                        },
                        complete: () => {
                            baseAnimSpine.state.setAnimation(0, "loop", true);
                            baseAnimSpine.state.clearListeners();
                            resolve();
                        },
                        start: () => {
                            baseAnimSpine.visible = true;
                        },
                    };
                this.texContainer.alpha = 1;
                //await this.appearText(true);
                //await wait(1000000);
                resolve();
                });
            };
            while(this.bannerText3.height > 360){
                this.bannerText3.style.fontSize -= 1;
            }
            promises.push(playInAnimation(this.baseAnim));
            //promises.push(playInAnimation(this.rightCharacter));

            Promise.all(promises).then(async () => {
                resolve();
            });

        })


    }

    private isTextVisible: boolean = false;

    protected appearText(toFreeGame: boolean) {

        return new Promise<void>((resolve) => {
            console.log("appearText called, isTextVisible:", this.isTextVisible,
                "alpha:", this.texContainer.alpha);


            if (this.isTextVisible) return; // prevent double-call flicker
            this.isTextVisible = true;

            const tweenAlpha = new Tween(this.texContainer, this.tweenGroup)
                .to({ alpha: 1 }, 300)
                .onStart(() => {
                    this.switchTheBackgroundMusic(toFreeGame);
                })
                .onComplete(() => {
                    this.eventMode = "static";
                    this.tweenGroup.remove(tweenAlpha);
                    resolve();
                })
                .start();

            const tweenBreath = new Tween(this.continueText.scale, this.tweenGroup)
                .to({ x: 1.03, y: 1.03 }, 1000)
                .yoyo(true)
                .repeat(Infinity)
                .onComplete(() => {
                    this.tweenGroup.remove(tweenBreath);
                    // resolve();
                })
                .start();
            //  const tweenBreathBase = new Tween(this.continueBase.scale, this.tweenGroup)
            //     .to({ x: 1.03, y: 1.03 }, 1000) 
            //     .yoyo(true) 
            //     .repeat(Infinity)
            //     .onComplete(() => {
            //         this.tweenGroup.remove(tweenBreathBase);
            //     })
            //     .start();

        })

    }

    private switchTheBackgroundMusic(toFreeGame: boolean) {

        let targetMusicLoop;
        let targetAmbient;
        if (toFreeGame) {
            targetMusicLoop = sound.find(SoundConstants.FG_LOOP);
            targetAmbient = SoundConstants.FREEGAME_AMBIENT;
        }
        else {
            targetMusicLoop = sound.find(SoundConstants.BG_LOOP);
            targetAmbient = SoundConstants.BASEGAME_AMBIENT;
        }

        let currentVal: number = currentBackgorundMusicVolume;
        let targetVal: number = 0;

        const tween = new Tween({ x: currentVal }, this.tweenGroup)
            .to({ x: targetVal }, 750)
            .onUpdate((object) => {
                currentBackgorundMusic.volume = object.x;
                // console.log("this.backGroundMusic", this.backGroundMusic.volume);
            })
            .onComplete(() => {
                this.tweenGroup.remove(tween);
                playFgMusic();

            })
            .start();


        const playFgMusic = () => {
            let currentVal: number = .10;
            let targetVal: number = currentBackgorundMusicVolume;

            // initialize with ambient sound
            setBackgorundMusic(targetMusicLoop);

            const tween = new Tween({ x: currentVal }, this.tweenGroup)
                .to({ x: targetVal }, 750)
                .onStart(() => {
                    currentBackgorundMusic.loop = true;
                    currentBackgorundMusic.singleInstance = true;
                    currentBackgorundMusic.play();
                    sound.play(targetAmbient, { volume: 0.1, loop: true });

                    currentBackgorundMusic.muted = !isMusicBtnOnGlobal;
                })
                .onUpdate((object) => {
                    currentBackgorundMusic.volume = object.x;

                    // console.log("this.backGroundMusic", this.backGroundMusic.volume);
                })
                .onComplete(() => {
                    this.tweenGroup.remove(tween);
                })
                .start();
        }
    }



    public async disappearBanner(): Promise<void> {
        return new Promise<void>(async (resolve) => {


            // if (!isBase) {
            //     this.switchTheBackgroundMusic(false);
            // }

            // this.texContainer.alpha = 1;
            this.texContainer.alpha = 1;
            this.isTextVisible = false
            // this.texContainer.scale = 1;

            await new Promise<void>((resolve) => {
                const tween = new Tween(this.backgroundImg, this.tweenGroup)
                    .to({ alpha: 1 }, 200)
                    .onComplete(() => {
                        this.tweenGroup.remove(tween);
                        resolve()
                    })
                    .start();
            })

            const promises: Promise<void>[] = [];

            const playOutAnimation = (baseAnimSpine: Spine) => {
                return new Promise<void>((resolve) => {
                    baseAnimSpine.state.setAnimation(0, "out", false).listener = {
                        complete: () => {
                            baseAnimSpine.state.clearListeners();
                             this.baseAnim.removeSlotObject("CLICK TO CONTINUE");
                            if(this.freegameCheck){
                                sound.play(SoundConstants.FS_TRANSITION, { volume: 1 });
                            }
                            else {
                                sound.play(SoundConstants.BASE_TRANSITION, { volume: 1 });
                            }
                            resolve();
                        }
                    };
                });
            };

            promises.push(playOutAnimation(this.baseAnim));
            Promise.all(promises).then(() => {
                this.visible = false;
                this.eventMode = "none";
                // this.bgContainer.cursor = 'none';
                resolve();
            });

        });
    }

    public async appearFreeGameOutroBanner(totalWin: number, freeSpins: number) {

        return new Promise<void>((resolve) => {
            this.eventMode = "static";
            this.cursor = "pointer";
            this.freegameCheck = false;
            this.isIntroBanner = false;

            this.visible = true;

            this.bannerText3.visible = false;
            // this.bannerText4.visible = false;
            // this.bannerText5.visible = false;

            this.winText.visible = true;

            this.bannerText1.scale.set(1);
            this.bannerText1.text = translationManager.game('banner_outro_heading_uc');// '8-BIT BONUS';
            this.bannerText1.scale.set(Math.min(1, 650 / this.bannerText1.width));
            this.bannerText1.y = -350;

            // this.bannerText2.scale = 1;

            this.bannerText2.text = translationManager.game('banner_outro_desc_1', null, { 'winnumber': freeSpins });
            this.bannerText2.y = -225;
            // this.bannerText2.scale = Math.min(1, 850 / this.bannerText2.width);


            this.winText.scale.set(1);
            this.winText.text = totalWin.toFixed(2);
            this.winText.scale.set(Math.min(1, 650 / this.winText.width));
            this.winText.y = 50;

            this.continueText.y = 350;

            this.resize(this.screenWidth, this.screenHeight); // to set the position according to screen size
            this.texContainerWrapper.visible = false;

            // Text should be visible and transform along with spine "in"
            // this.texContainer.alpha = 1;

            // this.texContainer.scale.set(1);

            const tween = new Tween(this.backgroundImg, this.tweenGroup)
                .to({ alpha: 1 }, 200)
                .onStart(() => {
                    sound.play('total_win', { volume: 1 });
                })
                .onComplete(() => {
                    this.tweenGroup.remove(tween);
                })
                .start();

            // sound.play('free_Game_Banner', { volume: 0.25 });
            const promises: Promise<void>[] = [];

            const playInAnimation = (baseAnimSpine: Spine) => {
                return new Promise<void>(async (resolve) => {
                    baseAnimSpine.visible = true;
                    sound.play(SoundConstants.BONUS_TOTAL_WIN, { volume: 1 });
                    baseAnimSpine.state.setAnimation(0, "in", false).listener = {
                        event: async (entry, event) => {
                            if (event.data.name === "event") {
                                console.log(".........", entry);
                                this.baseAnim.addSlotObject(
                                    "CLICK TO CONTINUE",
                                    this.texContainerWrapper
                                );
                                this.texContainerWrapper.visible = true;
                                //this.texContainer.alpha = 1;
                                //await this.appearText(true);
                                this.switchTheBackgroundMusic(true);
                            }
                        },
                        complete: () => {
                            baseAnimSpine.state.setAnimation(0, "loop", true);
                            baseAnimSpine.state.clearListeners();
                            resolve();
                        },
                        start: () => {
                            baseAnimSpine.visible = true;
                        },
                    };
                this.texContainer.alpha = 1;
                //await this.appearText(true);
                //await wait(1000000);
                resolve();
                });
            };
            promises.push(playInAnimation(this.baseAnim));
            //promises.push(playInAnimation(this.rightCharacter));

            Promise.all(promises).then(async () => {
                resolve();
            });

        })




    }



    public resize(screenWidth: number, screenHeight: number): void {

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        let scale: number;

        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / 1920, screenHeight / 1920);


        // this.rightCharacter.scale = 0.85;

        if (screenWidth > screenHeight) {
            scale = Math.min(screenWidth / 1920, screenHeight / 1080);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);




            // this.texContainerWrapper.scale.set(scale, scale);

            const xPos = (globalScreen * bgScale - screenWidth) / 2;
            const yPos = (globalScreen * bgScale - screenHeight) / 2;

            this.backgroundImg.scale.set(bgScale);
            this.backgroundImg.x = -xPos;
            this.backgroundImg.y = -yPos;

            this.bgContainer.scale.set(scale, scale)
            const bgXPos = (1920 * scale - screenWidth) / 2;
            const bgYPos = (1080 * scale - screenHeight) / 2;
            this.bgContainer.position.set(-bgXPos, -bgYPos);

            this.baseAnim.scale.set(0.75);
            this.baseAnim.position.set(960, 540);


            // this.rightCharacter.position.set(100, 750);
            if (this.isIntroBanner) {
                // this.bannerText1.y = -350;
                // this.bannerText2.y = -200;
                // this.bannerText3.y = 50;
                // // this.bannerText4.y = 100;
                // this.continueText.y = 350;
            }
            else if (!this.isIntroBanner) {
                // this.bannerText1.y = -350;
                // this.bannerText2.y = -200;
                // this.winText.y = 50;
                // this.continueText.y = 350;
            }

        }
        else {
            scale = Math.min(screenWidth / 1080, screenHeight / 1920);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);


            // this.texContainerWrapper.scale.set(scale, scale);

            const xPos = (globalScreen * bgScale - screenWidth) / 2;
            const yPos = (globalScreen * bgScale - screenHeight) / 2;

            this.backgroundImg.scale.set(bgScale);
            this.backgroundImg.x = -xPos;
            this.backgroundImg.y = -yPos;


            this.bgContainer.scale.set(scale, scale)
            const bgXPos = (1920 * scale - screenWidth) / 2;
            const bgYPos = (1080 * scale - screenHeight) / 2;
            this.bgContainer.position.set(-bgXPos, -bgYPos);

            this.baseAnim.scale.set(0.75);
            this.baseAnim.position.set(960, 540);
            // this.rightCharacter.position.set(100, 733);
            if (this.isIntroBanner) {
                // this.bannerText1.y = -350;
                // this.bannerText2.y = -200;
                // this.bannerText3.y = 50;
                // // this.bannerText4.y = 100;
                // this.continueText.y = 350;
            }
            else if (!this.isIntroBanner) {
                // this.bannerText1.y = -350;
                // this.bannerText2.y = -200;
                // // this.bannerText3.y = -57;
                // this.winText.y = 50;
                // this.continueText.y = 350;
            }

        }

        // this.texContainer.position.set(screenWidth / 2, screenHeight / 2);
        // this.texContainerWrapper.position.set(0, 0);
        // Sync continue base position with text
        // this.continueBase.y = this.continueText.y + 5;
        // this.continueBase.x = this.continueText.x; // (0,0 relative to container center)
    }

    public update(): void {
        // Update the tween group
        this.tweenGroup.update();

    }
}